export default __webpack_public_path__ + "static/media/basket.b305998d.png";